import {Injectable} from "@angular/core";
import { AuthToken } from "../models/Resources";

declare var localStorage: Storage;

@Injectable({
    providedIn: "root"
})
export class AccesTokenService {
    constructor() {

    }

    /**
    * set access token in storage
    * @param {AuthToken} new_access_token - the new access token
    */
    static setAccessToken(new_access_token: AuthToken) {
        localStorage.setItem('ring_token', new_access_token ? JSON.stringify(new_access_token) : null)
    }
   /**
    * get access token from storage
    */
    static getAccessToken(): AuthToken {

        return JSON.parse(localStorage.getItem('ring_token'));
    }

  /**
    * clear access token
    */

    static reset() {
        localStorage.removeItem('ring_token');
    }

}
